import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import PageControl from 'designer/component/control/page/CheckboxControl'
import FavoriteControl from 'designer/component/control/favorite/CheckboxControl'

export const PageCheckboxSystem = (props) => (
  <DragElementWrapper {...props}>
    <PageControl {...props} />
  </DragElementWrapper>
)

export const PageCheckboxDisplay = (props) => (
  <ElementWrapper {...props}>
    <PageControl {...props} />
  </ElementWrapper>
)

export const FavoriteCheckbox = (props) => (
  <ElementWrapper {...props}>
    <FavoriteControl {...props} />
  </ElementWrapper>
)

export const checkboxTester = rankWith(1000, scopeEndsWith('checkbox'))
